// extracted by mini-css-extract-plugin
module.exports = {"blueIconColor":"#2185d0","approvedColor":"#48ff5b","declinedColor":"#ff4869","pendingColor":"#ffab48","successColor":"#48ff5b","clearedColor":"#326ec8","amendedColor":"#ffa500"};